import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLoggedInUserId } from "../../../../../src/features/auth/logic/rbac";
import { useAppSelector } from "../../../../../src/app/store";
import { selectParticipantByType } from "../../../../../src/features/caseinfo/logic/ParticipantsSlice";
import { ParticipantType } from "../../../../../src/api/participants";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import { NavigateButton } from "../../../../../src/components/ui/button/v2/NavigateButton";
import { selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";
import { CaseRouteId, getCaseRoutePath } from "../../../../features/caselayout/config/caseRoutes";

const IoSubmitIRStage: React.FC = () => {
  const navigate = useNavigate();
  const { id: caseId } = useParams<{ id: string }>();

  const loggedInUserId = useLoggedInUserId();

  const investigatorParticipant = useAppSelector((state) =>
    selectParticipantByType(state, ParticipantType.INVESTIGATOR)
  );

  const investigatorId = investigatorParticipant?.participant_id;

  const isInvestigatingOfficer = loggedInUserId === investigatorId;

  const currentStage = useAppSelector(selectCurrentCaseStage);
  const notes = currentStage?.stage_data?.notes;

  const handleNavigate = () => {
    if (!caseId) return;
    navigate(getCaseRoutePath(caseId, CaseRouteId.IR));
  };

  if (isInvestigatingOfficer) {
    return (
      <WorkflowStageBanner
        title="Submit Investigation Report"
        description={
          <div className="flex flex-col">
            <span>
              1. Update your findings and observations in Investigation Workbench and upload Investigation Report as per the board approved format.
            </span>
            <span>
              2. Go to Investigation Report and do a final review. Click on Submit in the Investigation Report to forward the case.
            </span>
          </div>
        }
        customActions={
          <NavigateButton
            label="Investigation Workbench"
            onClick={handleNavigate}
          />
        }
        notes={notes} 
        className="gap-0"
      />
    );
  }

  return (
    <WorkflowStageInfoBanner
      title="Case under investigation by investigating officer"
    />
  );
};

export default IoSubmitIRStage;